import { createAction, props } from '@ngrx/store';
import { PageData } from './data-access-page.model';

export const currentDisplayedPagesReported = createAction(
  '[Catalog Iframe] current displayed pages reported',
  props<{ pages: PageData[] }>(),
);

export const downloadCurrentPagesClicked = createAction(
  '[DetailPage Catalog] download current pages',
  props<{ pageType: 'left' | 'right' | 'both' | null; documentId: number; categoryId: number; docuLanguage: string }>(),
);

export const downloadChapterClicked = createAction(
  '[DetailPage Catalog] download chapter',
  props<{ startPage: number; endPage: number; documentId: number; categoryId: number; docuLanguage: string }>(),
);

export const downloadPageStarted = createAction('[Page Download] download page started');

export const downloadPageCompleted = createAction('[Page Download] download page completed');

export const downloadPageFailed = createAction('[Page Download] download page failed');
